import { createEffect, createEvent, createStore, sample } from 'effector';
import { httpClient } from '@/api';
import { readJson, remove, writeJson } from '@/lib/storage';

const STORAGE_KEY = 'lume-verified';

const initialVerified = readJson<boolean>(STORAGE_KEY) === true;

export type DocType = 'passport' | 'id' | 'license';
export type ConsentKey = 'process' | 'kyc' | 'marketing';
export type KycStatusValue = 'not_started' | 'in_progress' | 'verified' | 'rejected';

export type KycStatusResponse = {
  status: KycStatusValue;
  docType: DocType | null;
  provider: string;
  verifiedAt: string | null;
};

export const verifiedSet = createEvent<boolean>();

export const $verified = createStore<boolean>(initialVerified).on(verifiedSet, (_, next) => next);

const persistFx = createEffect((on: boolean) => {
  if (on) writeJson(STORAGE_KEY, true);
  else remove(STORAGE_KEY);
});

sample({ clock: $verified, target: persistFx });

export const fetchKycStatusFx = createEffect<void, KycStatusResponse>(() =>
  httpClient.get<KycStatusResponse>('/api/lume/kyc/status'),
);

export const startKycFx = createEffect<
  { docType: DocType; consent: Record<ConsentKey, boolean> },
  KycStatusResponse
>((body) => httpClient.post<KycStatusResponse>('/api/lume/kyc/start', body));

export const confirmKycFx = createEffect<{ accepted: boolean }, KycStatusResponse>((body) =>
  httpClient.post<KycStatusResponse>('/api/lume/kyc/confirm', body),
);

sample({
  clock: [fetchKycStatusFx.doneData, startKycFx.doneData, confirmKycFx.doneData],
  fn: (r) => r.status === 'verified',
  target: verifiedSet,
});
